import { createSelector } from 'reselect';
import { getEvaluationState } from 'src/modules/evaluation/selectors/getEvaluationState';

export const getEvaluationGeneratedProposal = createSelector([
  getEvaluationState,
], (state) => state.generatedProposal);
